// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../build-tools/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../build-tools/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.llm-root {
    z-index: 53010 !important;
    width: 100%;
    background: #fff;
    height: 100%;
    display: flex;
}
.llm-anchor {
    z-index: 53001;
    position: sticky;
    left: 0;
    top: 0;
}

.llm-shadow {
    height: 100%;
}

.llm-view-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    height: 100%;
}

@media screen and (max-height: 540px) {
    .llm-view-container {
        overflow-y: auto;
    }
}

@media screen and (min-width: 450px) {
    .llm-root {
        z-index: 53010 !important;
        width: 320px;
        border-radius: 12px;
        box-shadow: 0 0 20px #454545;
        position: fixed;
        background: #fff;
        display: flex;
        height: calc(100vh - 110px)
    }

    .llm-shadow {
        z-index: 53000;
        position: fixed;
        width: 500px;
        height: 500px;
        bottom: 0;
        right: 0;
        background: radial-gradient(ellipse at bottom right, rgba(29, 39, 54, 0.16) 0, rgba(29, 39, 54, 0) 72%);
    }

    .llm-anchor {
        z-index: 53002;
        position: fixed;
        width: 0px;
        height: 0px;
        bottom: 0px;
        right: 0px;
    }
    .llm-view-container {
        flex: 1;
        display: flex;
        flex-direction: column;
    }
}

.llm-fill-available-space {
    width: 100%;
    height: 100%;
    background: unset;
}

.llm-fill-available-space > .llm-root {
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    border-radius: 0%;
    box-shadow: none;
}

.llm-anchor a,
.llm-anchor a:link,
.llm-anchor a:visited,
.llm-anchor a:focus,
.llm-anchor a:hover,
.llm-anchor a:active {
    color: inherit;
}

/** CSS Resets **/

.llm-anchor input[type="text"],
.llm-anchor input[type="text"]:focus,
.llm-anchor textarea,
.llm-anchor textarea:focus {
    border: none !important;
    box-shadow: none !important;
    margin: 0 !important;
    outline: 0 !important;
    display: block !important;
    min-width: 0 !important;
    box-sizing: content-box !important;
    background: none !important;
    -webkit-tap-highlight-color: transparent !important;
    font-style: normal !important;
    line-height: normal !important;
    min-height: 0;
    max-width: 100%;
}
.llm-anchor input,
.llm-anchor input[type="text"]:focus {
    height: 1.1875em !important;
    padding: 6px 0 7px !important;
}

.llm-anchor div,
.llm-anchor span {
    font-style: normal !important;
    font-weight: 400;
}

.llm-anchor [tabindex]:focus {
    outline: none;
}

.llm-anchor img {
    display: unset;
}

.llm-body-position {
    position: fixed;
}

.llm-anchor .conversation-footer-container {
    position: unset;
    height: 106px;
    display: flex;
    flex-direction: column;
   
}

.llm-anchor header {
    margin: 0px !important;
}

.llm-fill-available-space .llm-view-container{ 
    border: 1px solid rgb(0 0 0 / 10%);
    border-radius: 12px;
}

.llm-anchor .embla {
    overflow: hidden;
    height: 100%;
}
.llm-anchor .embla__container {
    display: flex;
    align-items: flex-start;
    transition: height 0.2s;
}
.llm-anchor .embla__slide {
    flex: 0 0 100%;
}

.llm-anchor .embla__container_hiw {
    height: 100%;
}
.llm-anchor .embla__slide_hiw {
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,OAAO;IACP,MAAM;AACV;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,YAAY;QACZ,mBAAmB;QACnB,4BAA4B;QAC5B,eAAe;QACf,gBAAgB;QAChB,aAAa;QACb;IACJ;;IAEA;QACI,cAAc;QACd,eAAe;QACf,YAAY;QACZ,aAAa;QACb,SAAS;QACT,QAAQ;QACR,uGAAuG;IAC3G;;IAEA;QACI,cAAc;QACd,eAAe;QACf,UAAU;QACV,WAAW;QACX,WAAW;QACX,UAAU;IACd;IACA;QACI,OAAO;QACP,aAAa;QACb,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;;;;;IAMI,cAAc;AAClB;;AAEA,iBAAiB;;AAEjB;;;;IAII,uBAAuB;IACvB,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;IACrB,yBAAyB;IACzB,uBAAuB;IACvB,kCAAkC;IAClC,2BAA2B;IAC3B,mDAAmD;IACnD,6BAA6B;IAC7B,8BAA8B;IAC9B,aAAa;IACb,eAAe;AACnB;AACA;;IAEI,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;;IAEI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,aAAa;IACb,sBAAsB;;AAE1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB","sourcesContent":[".llm-root {\n    z-index: 53010 !important;\n    width: 100%;\n    background: #fff;\n    height: 100%;\n    display: flex;\n}\n.llm-anchor {\n    z-index: 53001;\n    position: sticky;\n    left: 0;\n    top: 0;\n}\n\n.llm-shadow {\n    height: 100%;\n}\n\n.llm-view-container {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    height: 100%;\n}\n\n@media screen and (max-height: 540px) {\n    .llm-view-container {\n        overflow-y: auto;\n    }\n}\n\n@media screen and (min-width: 450px) {\n    .llm-root {\n        z-index: 53010 !important;\n        width: 320px;\n        border-radius: 12px;\n        box-shadow: 0 0 20px #454545;\n        position: fixed;\n        background: #fff;\n        display: flex;\n        height: calc(100vh - 110px)\n    }\n\n    .llm-shadow {\n        z-index: 53000;\n        position: fixed;\n        width: 500px;\n        height: 500px;\n        bottom: 0;\n        right: 0;\n        background: radial-gradient(ellipse at bottom right, rgba(29, 39, 54, 0.16) 0, rgba(29, 39, 54, 0) 72%);\n    }\n\n    .llm-anchor {\n        z-index: 53002;\n        position: fixed;\n        width: 0px;\n        height: 0px;\n        bottom: 0px;\n        right: 0px;\n    }\n    .llm-view-container {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n    }\n}\n\n.llm-fill-available-space {\n    width: 100%;\n    height: 100%;\n    background: unset;\n}\n\n.llm-fill-available-space > .llm-root {\n    width: calc(100% - 2px);\n    height: calc(100% - 2px);\n    border-radius: 0%;\n    box-shadow: none;\n}\n\n.llm-anchor a,\n.llm-anchor a:link,\n.llm-anchor a:visited,\n.llm-anchor a:focus,\n.llm-anchor a:hover,\n.llm-anchor a:active {\n    color: inherit;\n}\n\n/** CSS Resets **/\n\n.llm-anchor input[type=\"text\"],\n.llm-anchor input[type=\"text\"]:focus,\n.llm-anchor textarea,\n.llm-anchor textarea:focus {\n    border: none !important;\n    box-shadow: none !important;\n    margin: 0 !important;\n    outline: 0 !important;\n    display: block !important;\n    min-width: 0 !important;\n    box-sizing: content-box !important;\n    background: none !important;\n    -webkit-tap-highlight-color: transparent !important;\n    font-style: normal !important;\n    line-height: normal !important;\n    min-height: 0;\n    max-width: 100%;\n}\n.llm-anchor input,\n.llm-anchor input[type=\"text\"]:focus {\n    height: 1.1875em !important;\n    padding: 6px 0 7px !important;\n}\n\n.llm-anchor div,\n.llm-anchor span {\n    font-style: normal !important;\n    font-weight: 400;\n}\n\n.llm-anchor [tabindex]:focus {\n    outline: none;\n}\n\n.llm-anchor img {\n    display: unset;\n}\n\n.llm-body-position {\n    position: fixed;\n}\n\n.llm-anchor .conversation-footer-container {\n    position: unset;\n    height: 106px;\n    display: flex;\n    flex-direction: column;\n   \n}\n\n.llm-anchor header {\n    margin: 0px !important;\n}\n\n.llm-fill-available-space .llm-view-container{ \n    border: 1px solid rgb(0 0 0 / 10%);\n    border-radius: 12px;\n}\n\n.llm-anchor .embla {\n    overflow: hidden;\n    height: 100%;\n}\n.llm-anchor .embla__container {\n    display: flex;\n    align-items: flex-start;\n    transition: height 0.2s;\n}\n.llm-anchor .embla__slide {\n    flex: 0 0 100%;\n}\n\n.llm-anchor .embla__container_hiw {\n    height: 100%;\n}\n.llm-anchor .embla__slide_hiw {\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
